// --- Core ---
import {closeSnackbar, enqueueSnackbar, OptionsObject, SnackbarKey, SnackbarMessage} from "notistack";
// --- Material UI ---
import {IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const defaultOptions: OptionsObject = {
  anchorOrigin: {horizontal: 'right', vertical: 'bottom'},
  variant: 'default',
  autoHideDuration: 4000,
  preventDuplicate: true
};

function displayEnqueuedSnackbar(message: SnackbarMessage, customOptions = {}) {
  const options: OptionsObject = {
    ...defaultOptions, //This uses the default options
    ...customOptions  //Overwrites default option with custom options
  };
  enqueueSnackbar(message, options);
}

function displaySnackbar(message: SnackbarMessage, options: OptionsObject = {}) {
  return displayEnqueuedSnackbar(message, options);
}

function displayErrorbar(message: SnackbarMessage, options: OptionsObject = {}) {
  const errorOptions: OptionsObject<"error"> = {...options, variant: 'error'};

  return displayEnqueuedSnackbar(message, errorOptions);
}


function notificationCloseButton(key: SnackbarKey) {
  return (
    <IconButton
      color="primary"
      key="close"
      aria-label="Close"
      onClick={() => closeSnackbar(key)}
    >
      <CloseIcon/>
    </IconButton>
  );
}


export {
  notificationCloseButton,
  displaySnackbar,
  displayErrorbar
};
